import { useState } from "react";

const Stepper = ({getTitleClass}) => {
    

    return ( 
      <div className="bs-stepper-header">
        <div className={`step ${getTitleClass(1)}`}>
          <button type="button" className="step-trigger">
            <span className="bs-stepper-circle">1</span>
            <span className="bs-stepper-label mt-1">
              <span className="bs-stepper-title">Document Selection</span>
              <span className="bs-stepper-subtitle">Document Details</span>
            </span>
          </button>
        </div>
        <div className="line">
          <i className="bx bx-chevron-right" />
        </div>
        <div className={`step ${getTitleClass(2)}`}>
          <button type="button" className="step-trigger" disabled="disabled" >
            <span className="bs-stepper-circle">2</span>
            <span className="bs-stepper-label mt-1">
              <span className="bs-stepper-title">Requirements</span>
              <span className="bs-stepper-subtitle">Upload Requirements & Documents</span>
            </span>
          </button>
        </div>
        <div className="line">
          <i className="bx bx-chevron-right" />
        </div>
        <div className={`step ${getTitleClass(3)}`}>
          <button type="button" className="step-trigger" disabled="disabled" >
            <span className="bs-stepper-circle">3</span>
            <span className="bs-stepper-label mt-1">
              <span className="bs-stepper-title">Personal Info</span>
              <span className="bs-stepper-subtitle">Add personal info</span>
            </span>
          </button>
        </div>

        <div className="line">
          <i className="bx bx-chevron-right" />
        </div>
        <div className={`step ${getTitleClass(4)}`}>
          <button type="button" className="step-trigger" disabled="disabled" >
            <span className="bs-stepper-circle">4</span>
            <span className="bs-stepper-label mt-1">
              <span className="bs-stepper-title">Payment</span>
              <span className="bs-stepper-subtitle">Payment Info</span>
            </span>
          </button>
        </div>
        <div className="line">
          <i className="bx bx-chevron-right" />
        </div> 
        <div className={`step ${getTitleClass(5)}`}>
          <button type="button" className="step-trigger" disabled="disabled" >
            <span className="bs-stepper-circle">5</span>
            <span className="bs-stepper-label mt-1">
              <span className="bs-stepper-title">Review & Save</span>
              <span className="bs-stepper-subtitle">Application Info</span>
            </span>
          </button>
        </div>
      </div>
     );
}
 
export default Stepper;